import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [자동화>자동화 수행] 자동화 수행을 위한 트리거 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerList(params) {
    return axios.post(`${baseUrl}/ams/execution/get-trigger-list.do`, params);
  },

  /**
   * [자동화>자동화 수행] 선택한 트리거에 속해있는 job 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerJobListByTriggerId(params) {
    return axios.post(`${baseUrl}/ams/execution/get-trigger-job-list-by-trigger-id.do`, params);
  },

  /**
   * [자동화>자동화 수행] 선택한 트리거에 속해있는 job별 node 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerNodeListByJobId(params) {
    return axios.post(`${baseUrl}/ams/execution/get-trigger-node-list-by-job-id.do`, params);
  },

  /**
   * [자동화>자동화 수행] 선택한 잡의 장비를 설정
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  updateTriggerNodeList(params) {
    return axios.post(`${baseUrl}/ams/execution/update-trigger-node-list.do`, params);
  },

  /**
   * [자동화>자동화 수행] 트리거 목록 엑셀 파일 출력
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportTriggerListExcel(params) {
    return axios.post(`${baseUrl}/ams/execution/export-trigger-list-excel.do`, params);
  },

  /**
   * [자동화>자동화 수행] 트리거 직접 수행
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeDirectTrigger(params) {
    return axios.post(`${baseUrl}/ams/execution/execute-direct-trigger.do`, params);
  },

  /**
   * [자동화>자동화 수행] 트리거 직접 수행 진행률 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDirectTriggerExecProgressRate(params) {
    return axios.post(`${baseUrl}/ams/execution/get-direct-trigger-exec-progress-rate.do`, params);
  },

  /**
   * [자동화>자동화 수행] 장비 일괄 적용 기능 수행
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  applyTriggerNode(params) {
    return axios.post(`${baseUrl}/ams/execution/apply-trigger-node.do`, params);
  },
  /**
   * [자동화>자동화 수행] 장비 일괄 적용 기능 수행
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTriggerCountListByGrpId(params) {
    return axios.post(`${baseUrl}/ams/execution/get-trigger-count-list-by-grp-id.do`, params);
  },
  /**
   * [자동화>자동화 수행] 트리거 직접 수행시 설정할 대상 장비 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNodeList(params) {
    return axios.post(`${baseUrl}/ams/execution/get-node-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/ams/execution.js